export default __webpack_public_path__ + "static/media/thumbnail1.9060c8b2.jpg";